import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonGroupVertical = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Vertical contained button group"}
        height={"150px"}
        value={
          '<ButtonGroup orientation="vertical" aria-label="vertical contained button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup
          orientation="vertical"
          aria-label="vertical contained button group"
        >
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonGroupVertical;
